import React, { useState, useEffect } from "react";
import { Col, FormGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { Input } from "reactstrap";
import { Oval } from 'react-loader-spinner'

import { allsellItemFromCollectionId, getNewCollectionByIdStart } from "store/actions";
export default function ViewCollection() {
    const [menu, menuopen] = useOutletContext();
    useEffect(() => {
        menu(false)
    }, [menu])
    const { id } = useParams()
    const dispatch = useDispatch()
    const collection = useSelector((selector) => selector?.collections.collection);
    const username = useSelector((selector2) => selector2?.Login.user.username);
    const { sellItemFromCollectionID, loading } = useSelector((selector2) => selector2?.SellItems);
    const { user } = useSelector((state) => state?.Login);
    const [search, setSearch] = useState('')
    const [nftData, setNftData] = useState([])
    useEffect(() => {
        if (collection?._id) {
            let data = {}
            data.collection_id = collection?._id
            dispatch(allsellItemFromCollectionId(data))
        }
    }, [collection, dispatch])
    useEffect(() => {
        const callback = (res) => {
        }
        dispatch(getNewCollectionByIdStart(id, callback))
    }, [])
    const [sumOfAllSellItemPrice, setSumOfAllSellItemPrice] = useState(0)
    useEffect(() => {
        if (search === '') {
            setNftData(sellItemFromCollectionID)
        } else {
            setNftData(sellItemFromCollectionID?.filter((item) => { return search === '' ? item : item?.nft_id?.name?.toLowerCase().includes(search.toLowerCase()) }))
        }
        let initialValue = 0
        for (let i = 0; i < sellItemFromCollectionID.length; i++) {
            initialValue += sellItemFromCollectionID[i]?.price
        }
        setSumOfAllSellItemPrice(initialValue)
    }, [search, sellItemFromCollectionID])
    const handleSearch = (e) => {
        setSearch(e)
    }

    useEffect(() => {
   
    }, [])

    return (
        <>
            {loading &&
                <div className='loaderBoxMiane'>
                    <Oval
                        height={80}
                        width={80}
                        color="#6C63FF"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                        ariaLabel='oval-loading'
                        secondaryColor="#6C63FF"
                        strokeWidth={2}
                        strokeWidthSecondary={2}
                    />
                </div>
            }
            <Row>
                <Col lg={12}>
                    <div className="collectionProfile profilecoll">
                        <div className="profileBoXIn pb-4">
                            <div className="profileImgbx">
                                <img src={collection.image?.link} alt="" />
                                {/* "/images/png/digitalartimg3.png" */}
                            </div>
                        </div>
                        <div className="profileCollection">
                            {/* <button className="editColelction btn btn-outline-dark px-4"><i class="fa-regular fa-pen-line"></i> Edit Collection</button> */}
                            <div className="profilecollCont">
                                <h1>{collection?.name}</h1>
                                <p>{username}</p>
                                <div className="btn btn-dark px-4 me-2 cursor-auto">Items - {sellItemFromCollectionID?.length} </div>
                                <div className="btn btn-secondary text-white px-4 ms-2 cursor-auto">Volume -  {sumOfAllSellItemPrice.toFixed(6)} POL</div>

                            </div>
                            {/* <button className="addnft btn btn-outline-dark px-4"><i class="fa-regular fa-pen-line"></i> Add  NFT’s</button> */}
                        </div>
                        <p className="profileTextCollView">
                            {collection?.description}
                        </p>
                    </div>
                    <Row className="justify-content-between searchcoll mb-4">
                        <Col lg={6}>
                            <FormGroup className="position-relative">
                                <Input className="form-control searchInput" placeholder="Search for Digital Artworks" onChange={(e) => handleSearch(e.target.value)} />
                                <button className="btn position-absolute end-0 top-0 bottom-0 my-auto border-0"><i className="fa-light fa-magnifying-glass"></i></button>
                            </FormGroup>
                            {/* <p className="pdecription pdecriptioncol">Showing 350 NFT's</p> */}
                        </Col>
                        {/* <Col lg={4}>
                            <div className="d-flex align-item-center gap-3">
                                <Input type="select" className="form-control searchInput shadow-none">

                                    <option>Low to High</option>
                                    <option>High to Low</option>

                                </Input>
                                <Input type="select" className="form-control searchInput shadow-none">
                                    <option>DAILY</option>
                                    <option>WEEKLY</option>
                                </Input>
                                <button className="btn border-0 clearfilter p-0">
                                    <i className="fa-solid fa-filter-circle-xmark"></i>
                                </button>
                            </div>
                        </Col> */}
                    </Row>
                    <div className="collectionProfile">
                        <Row>
                            {nftData && nftData.length > 0 ? (
                                <>
                                    {nftData.map((item, index) =>
                                        <Col className="mb-4" lg={4} key={index}>
                                            <Link className="text-decoration-none" to={`/profile/collection/viewNft/${item?._id}`} >
                                                <div className="artItemBoxNew nftBox">
                                                    <div className="imgBox">
                                                        <img src={(user?._id && user?._id === item?.owner_id?._id) ? item?.nft_id?.image_id?.image?.link : item?.nft_id?.image_id?.image?.water_mark_image_link ? item?.nft_id?.image_id?.image?.water_mark_image_link : item?.nft_id?.image_id?.image?.link} alt="" />
                                                        <div className="actionType">{item.sellType}</div>
                                                    </div>
                                                    <div className="contBox mt-3">
                                                        <div className="arthead gap-3 mb-2">
                                                            {/* <h2 className="productName" id="ellipse-text">{item?.nft_id?.name}</h2> */}
                                                    
<h2 className="productName" id="ellipse-text" data-toggle="tooltip" title={item?.nft_id?.name}>{item?.nft_id?.name}</h2>

{/* <div class="tooltip bs-tooltip-top" role="tooltip">
  <div class="arrow"></div>
  <div class="tooltip-inner">
  {item?.nft_id?.name}
  </div>
</div> */}



                                                            <h2 className="productPrice">{item?.price} POL</h2>
                                                        </div>
                                                        <p >{item?.nft_id?.description}</p>
                                                        <div className="viewAndLike">
                                                            <p>
                                                                <i className="fa-regular fa-eye"></i>
                                                                <span>Views</span>
                                                                {item?.view_count}
                                                            </p>
                                                            <p>
                                                                <i className="fa-regular fa-heart"></i>
                                                                <span>Likes</span>
                                                                {item?.like_count}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </Col>)}
                                </>
                            ) : (<>
                                <div className="text-center d-grid justify-content-center dataNotFound py-5">
                                    <img src={"/images/svg/mpdatanft.svg"} className="mb-4" alt="Create collection" />
                                    <h3>No Data Available</h3>
                                </div>
                            </>)}


                        </Row>
                    </div>
                </Col>
            </Row>
        </>
    )

}